import * as React from 'react';
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { Checkbox } from 'primereact/checkbox';
import Translate from '../../common/functions/translate';

const ProductList = (props) => {
    return (
        <DataTable
            value={props.products}
            responsive
            paginator={true}
            lazy={true}
            rows={props.rows}
            rowsPerPageOptions={[10, 20, 50, 100]}
            totalRecords={props.totalRecords}
            onPage={(event) => props.onPageClick(event)}
            first={props.first}
            dataKey='productId'
            selectionMode='single'
            onRowClick={(e) => props.editClick(e.data.productId)}
        //loading={props.isLoading}	
        >
            <Column field="articleNumber" header={Translate("Article number")} style={{ width: '10%' }} />
            <Column field="article" header={Translate("Article")} style={{ width: '25%' }} />
            <Column field="brand" header={Translate("Brand")} />
            <Column
                field="power"
                className='data-table-cell'
                header={`${Translate("Power")} (kW)`}
                style={{ width: '10%' }}
                body={(rowData, column) =>
                    <>
                        {rowData.power ? rowData.power : ''}
                        {rowData.secondPower ? rowData.power ? "/" + rowData.secondPower : rowData.secondPower : ''}
                    </>
                }
            />
            {/* <Column field="model" header={Translate("Model")} /> */}
            <Column field="supplier" header={Translate("Supplier")} />
            <Column
                field="priceFromSupplier"
                className='data-table-cell'
                //header={Translate("Price from supplier")}
                header={Translate("PriceFromSupplier")}
                style={{ width: '10%' }}
                body={(rowData, column) =>
                    <>
                        {rowData.priceFromSupplier.toFixed(2)}
                    </>
                }
            />
            <Column
                field="price"
                className='data-table-cell'
                header={Translate("Price")}
                style={{ width: '10%' }}
                body={(rowData, column) =>
                    <>
                        {rowData.price.toFixed(2)}
                    </>
                }
            />
            <Column
                style={{ width: "8em" }}
                className='data-table-cell'
                field="isActive"
                header={Translate("Active")}
                body={(rowData, column) =>
                    <>
                        <Checkbox
                            readOnly={true}
                            disabled={true}
                            checked={rowData.isActive}
                            onChange={() => null}
                        />
                    </>
                }
            />
            <Column
                header={Translate("Actions")}
                style={{ width: "8em" }}
                className='data-table-cell'
                body={(rowData, column) =>
                    <>
                        <Button
                            type="button"
                            icon="pi pi-pencil"
                            className="p-button-warning"
                            tooltip={Translate("Edit")}
                            tooltipOptions={{ position: 'top' }}
                            style={{ marginRight: ".5em" }}
                        //onClick={() => props.editClick(rowData.productId, rowData)}
                        />
                        <Button
                            type="button"
                            icon="pi pi-trash"
                            className="p-button-danger"
                            tooltip={Translate("Delete")}
                            tooltipOptions={{ position: 'top' }}
                            onClick={(e) => props.deleteClick(rowData.productId, e)}
                        />
                    </>
                }
            />
        </DataTable>
    )
}

export default ProductList;
